import BaseComponent from "../BaseComponent";
import ColorBoxInput from "components/Properties/InputComponents/ColorboxInput";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import DirectionInput from "components/Properties/InputComponents/DirectionInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const ParticleBehaviorComponent = ({selectedObject, inputOnChange, colorOnChange, transformOnChange, checkboxOnChange}) => {
  let particleSystem = null;
  let isAttractionActive = false;
  let isForceActive = false;
  let isRandomDriftActive = false;
  let isSpringActive = false;
  let particleColor = {};
  let particleScale = {};
  let particleAlpha = {};
  let particleForce = {};
  let attraction = {};
  let randomDrift = {};
  let spring = {};
  let attractionDirection = {};
  let particleForceDirection = {};
  let randomDriftDirection = {};
  let springDirection = {};

  isAttractionActive = selectedObject.userData.isAttractionActive;
  isForceActive = selectedObject.userData.isForceActive;
  isRandomDriftActive = selectedObject.userData.isRandomDriftActive;
  isSpringActive = selectedObject.userData.isSpringActive;

  if (selectedObject.userData.type === "particleSystem") {
    particleSystem = selectedObject.userData.system;

    particleColor = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Color";
    });
    particleScale = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Scale";
    });
    particleAlpha = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Alpha";
    });
    particleForce = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Force";
    });
    attraction = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Attraction";
    });
    randomDrift = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "RandomDrift";
    });
    spring = particleSystem.emitters[0].behaviours.find(behavior => {
      return behavior.type === "Spring";
    });

    particleForceDirection.x = particleForce?.properties.fx;
    particleForceDirection.y = particleForce?.properties.fy;
    particleForceDirection.z = particleForce?.properties.fz;
    attractionDirection.x = attraction?.properties.x;
    attractionDirection.y = attraction?.properties.y;
    attractionDirection.z = attraction?.properties.z;
    randomDriftDirection.x = randomDrift?.properties.x;
    randomDriftDirection.y = randomDrift?.properties.y;
    randomDriftDirection.z = randomDrift?.properties.z;
    springDirection.x = spring?.properties.x;
    springDirection.y = spring?.properties.y;
    springDirection.z = spring?.properties.z;
  }

  if (selectedObject.name === "ParticleSystem" && particleSystem) {
    return (
      <BaseComponent title="Particle Behavior" foldable={true}>
        <NumberSliderInput
          name="AlphaStart"
          value={particleAlpha.properties.alphaA}
          min={0}
          max={1}
          step={0.1}
          inputOnChange={inputOnChange}
        />
        <NumberSliderInput
          name="AlphaEnd"
          value={particleAlpha.properties.alphaB}
          min={0}
          max={1}
          step={0.1}
          inputOnChange={inputOnChange}
        />
        <NumberSliderInput
          name="ScaleStart"
          value={particleScale.properties.scaleA}
          min={0}
          max={100}
          step={0.1}
          inputOnChange={inputOnChange}
        />
        <NumberSliderInput
          name="ScaleEnd"
          value={particleScale.properties.scaleB}
          min={0}
          max={100}
          step={0.1}
          inputOnChange={inputOnChange}
        />
        <ColorBoxInput name="ColorStart" objectColor={particleColor.properties.colorA} colorOnChange={colorOnChange} />
        <ColorBoxInput name="ColorEnd" objectColor={particleColor.properties.colorB} colorOnChange={colorOnChange} />
        <ToggleInput name="AttractionActive" checked={isAttractionActive} checkboxOnChange={checkboxOnChange} />
        {isAttractionActive && (
          <>
            <DirectionInput
              name="Attraction"
              value={attractionDirection}
              transformOnChange={transformOnChange}
              is2D={selectedObject.isSprite}
              depth={1}
            />
            <NumberSliderInput
              name="Attraction Force"
              value={attraction?.properties.force}
              min={0}
              max={100}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
          </>
        )}
        <ToggleInput name="ForceActive" checked={isForceActive} checkboxOnChange={checkboxOnChange} />
        {isForceActive && (
          <DirectionInput
            name="Force"
            value={particleForceDirection}
            transformOnChange={transformOnChange}
            is2D={selectedObject.isSprite}
            depth={1}
          />
        )}
        <ToggleInput name="RandomDriftActive" checked={isRandomDriftActive} checkboxOnChange={checkboxOnChange} />
        {isRandomDriftActive && (
          <DirectionInput
            name="RandomDrift"
            value={randomDriftDirection}
            transformOnChange={transformOnChange}
            is2D={selectedObject.isSprite}
            depth={1}
          />
        )}
        <ToggleInput name="SpringActive" checked={isSpringActive} checkboxOnChange={checkboxOnChange} />
        {isSpringActive && (
          <>
            <DirectionInput
              name="SpringDirection"
              value={springDirection}
              transformOnChange={transformOnChange}
              is2D={selectedObject.isSprite}
              depth={1}
            />
            <NumberSliderInput
              name="Spring Factor"
              value={spring?.properties.spring}
              min={0}
              max={100}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
            <NumberSliderInput
              name="Spring Friction"
              value={spring?.properties.friction}
              min={0}
              max={100}
              step={0.1}
              inputOnChange={inputOnChange}
              depth={1}
            />
          </>
        )}
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default ParticleBehaviorComponent;
